import Vue from 'vue'
import router from './router'
import App from './App.vue'
import ElementUI from 'element-ui'
import moment from 'moment'
import _ from 'lodash'
import 'element-ui/lib/theme-chalk/index.css'

import "@/assets/style/global.less"

Vue.config.productionTip = false

Vue.use(ElementUI)

Object.defineProperty(Vue.prototype, "$moment", { value: moment });
Object.defineProperty(Vue.prototype, "$_", { value: _ });

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
